import {PersonalPlanningWish} from '@cquential/api';
import Dates from '@cquential/date-utils';

export default class WishUtil {
    public static wantsFullDayOff(wish: PersonalPlanningWish): boolean {
        if (!wish.doesntWantToWorkBegin || !wish.doesntWantToWorkEnd) {
            return false;
        }

        return Dates.Utils.diffInDays(wish.doesntWantToWorkEnd, wish.doesntWantToWorkBegin) === 1
            && Dates.Formatter.formatTime(wish.doesntWantToWorkBegin) === '00:00'
            && Dates.Formatter.formatTime(wish.doesntWantToWorkEnd) === '00:00';
    }

    public static isWishPreferenceFulfilled(wish: PersonalPlanningWish, shiftId: number): boolean {
        const wantedShifts: number[] = [wish.wantsShiftId1, wish.wantsShiftId2, wish.wantsShiftId3]
            .filter((shiftId: number | null): shiftId is number => shiftId !== null);

        return wantedShifts.length > 0 && !wantedShifts.includes(shiftId);
    }

    public static hasWishConflicts(wish: PersonalPlanningWish, shiftId: number, startDateTime: Date | undefined, endDateTime: Date | undefined): boolean {
        if (this.isWishPreferenceFulfilled(wish, shiftId)) {
            return true;
        }

        if (!wish.doesntWantToWorkBegin || !wish.doesntWantToWorkEnd) {
            return false;
        }

        if (this.wantsFullDayOff(wish)) {
            return true;
        }

        if (!startDateTime || !endDateTime) {
            return false;
        }

        return Dates.compare(startDateTime).isBetweenDatesInclusive(wish.doesntWantToWorkBegin, wish.doesntWantToWorkEnd)
            || Dates.compare(endDateTime).isBetweenDatesInclusive(wish.doesntWantToWorkBegin, wish.doesntWantToWorkEnd);
    }
}
